// src/admin/RoutePreview.js
import React, { useState } from 'react';
import StoreCard from '../store/StoreCard';

function RoutePreview({
  routeName,
  showInStore,
  storeTagline,
  storeStatus,
  storePrice,
  storeBulletPoints = [],
  storeImages = [],
  cardBackgroundImage,
  cardOverlayColor,
  cardOverlayOpacity,
  cardColors = {
    primaryColor: '#FFD700',
    secondaryColor: '#FFFFFF',
    backgroundColor: '#072231'
  },
}) {
  const [isFlipped, setIsFlipped] = useState(false);
  const [showBackContent, setShowBackContent] = useState(false);

  const handleFlip = () => {
    if (!isFlipped) {
      // Flipping to back - start CSS animation immediately, switch content at 160ms
      setIsFlipped(true);
      setTimeout(() => setShowBackContent(true), 160);
    } else {
      // Flipping to front - start CSS animation immediately, switch content at 160ms
      setIsFlipped(false);
      setTimeout(() => setShowBackContent(false), 160);
    }
  };

  const handleInauguralClick = () => {
    // Show inaugural info modal (placeholder for now)
    alert('Inaugural Phase: All bookings are handled personally by our travel agents with dedicated support.');
  };

  // Create a mock route object that matches the StoreCard's expected format
  const mockRoute = {
    name: routeName || 'Route Name',
    storeTagline: storeTagline || 'Your adventure awaits',
    storeStatus: storeStatus || 'beta',
    storeCoverImage: storeImages && storeImages.length > 0 ? storeImages[0] : null,
    storeBulletPoints: storeBulletPoints || [],
    cardColors: cardColors,
    cardBackgroundImage: cardBackgroundImage || null,
    cardOverlayColor: cardOverlayColor || 'rgba(0, 0, 0, 0.4)',
    cardOverlayOpacity: cardOverlayOpacity !== undefined ? cardOverlayOpacity : 0.4
  };

  // Debug logging
  console.log('RoutePreview Debug:', {
    routeName,
    storeImages,
    extractedImage: mockRoute.storeCoverImage,
    cardColors
  });

  const isPriceAvailable = storeStatus !== 'coming-soon' && storeStatus !== 'hidden';

  return (
    <div style={{
      width: '100%',
      minHeight: '500px',
      margin: '0 auto',
      background: 'rgba(7, 34, 49, 0.9)',
      padding: '20px',
      borderRadius: '10px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      boxSizing: 'border-box'
    }}>
      <h3 style={{
        color: '#FFD700',
        marginBottom: '20px',
        textAlign: 'center',
        fontSize: '1.2rem',
        fontWeight: '500'
      }}>
        Store Preview: {routeName}
      </h3>

      {/* Render the actual StoreCard component - exact same as in store */}
      <div style={{
        width: '250px', // Match StoreCard base width
        height: '406px', // Match StoreCard base height
        margin: '0 auto'
      }}>
        <StoreCard
          route={mockRoute}
          isFlipped={isFlipped}
          showBackContent={showBackContent}
          isPriceAvailable={isPriceAvailable}
          onFlip={handleFlip}
          onPriceClick={() => {}}
          onInauguralClick={handleInauguralClick}
        />
      </div>

      <div style={{
        textAlign: 'center',
        marginTop: '15px',
        color: '#999',
        fontSize: '0.85rem',
        fontStyle: 'italic'
      }}>
        Click the flip icon to see {isFlipped ? 'front' : 'back'} side
      </div>
    </div>
  );
}

export default RoutePreview;
